// extracted by mini-css-extract-plugin
export default {"root":"BookCover_root__daYjR","fallback":"BookCover_fallback__5wx8X","brand":"BookCover_brand__4rTDb"};